import React from "react";
import { ChevronDown, SlidersHorizontal } from "lucide-react";
import {
  MobileCategoryFilterSection,
  mobileCategoryFilterSections,
} from "../CategoryListingTypes";

interface CategoryMobileFilterRailProps {
  activeMobileFilterCount: number;
  getMobileFilterCount: (section: MobileCategoryFilterSection) => number;
  onOpenMobileFilter: (section: MobileCategoryFilterSection) => void;
}

// Chips shown on the horizontal rail (excluding 'sort' which is in the main button)
const railFilterSections = mobileCategoryFilterSections.filter(
  (sec) => sec.id !== "sort"
);

export const CategoryMobileFilterRail: React.FC<CategoryMobileFilterRailProps> = ({
  activeMobileFilterCount,
  getMobileFilterCount,
  onOpenMobileFilter,
}) => {
  return (
    <div className="category-mobile-filter-chip-rail" role="region" aria-label="Quick filters">
      <button
        type="button"
        className={`category-mobile-filter-chip category-mobile-filter-chip-main ${
          activeMobileFilterCount > 0 ? "active" : ""
        }`}
        onClick={() => onOpenMobileFilter("sort")}
        aria-label="Open all filters and sorting"
      >
        <SlidersHorizontal size={16} strokeWidth={2} />
        <span>Sort & Filter</span>
        {activeMobileFilterCount > 0 && <strong>{activeMobileFilterCount}</strong>}
      </button>

      {railFilterSections.map((filter) => {
        const count = getMobileFilterCount(filter.id);
        return (
          <button
            type="button"
            key={filter.id}
            className={`category-mobile-filter-chip ${count > 0 ? "active" : ""}`}
            onClick={() => onOpenMobileFilter(filter.id)}
            aria-label={`Filter by ${filter.label}${count > 0 ? `, ${count} selected` : ""}`}
          >
            <span>{filter.label}</span>
            {count > 0 && <strong>{count}</strong>}
            <ChevronDown size={14} strokeWidth={2} />
          </button>
        );
      })}
    </div>
  );
};

export default CategoryMobileFilterRail;
